export const ADD_PROJECT = 'ADD_PROJECT'
export const REMOVE_PROJECT = 'REMOVE_PROJECT'
export const RENAME_PROJECT = 'RENAME_PROJECT'
export const DUPLICATE_PROJECT = 'DUPLICATE_PROJECT'
export const ADD_REQUEST = 'ADD_REQUEST'
export const UPDATE_REQUEST = 'UPDATE_REQUEST'
export const DELETE_REQUEST = 'DELETE_REQUEST'
export const RENAME_REQUEST = 'RENAME_REQUEST'
export const DUPLICATE_REQUEST = 'DUPLICATED_REQUEST'
export const PIN_REQUEST = 'PIN_REQUEST'
export const ADD_FOLDER = 'ADD_FOLDER'
export const DELETE_FOLDER = 'DELETE_FOLDER'
export const RENAME_FOLDER = 'RENAME_FOLDER'
